import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux'
import H1 from "../../Components/H1";
import { ToolbarWithLogo } from '../../Components/Toolbar';
import ContainerPage, { PICK_SERVICES_PATH, Routes } from "../ContainerPage";
import { BottomWrapper, CoreWrapper, TopWrapper } from '../../Components/Layout';
import PoweredBy from "../../Components/PoweredBy";
import { CSSTransition } from "react-transition-group";
import ProgressTracker from "../../Components/ProgressTracker";
import Toast from "../../Components/Toast";
import H2 from "../../Components/H2";
import styled from "styled-components";

import {
	CenterContainer,
	FullWidthInput,
	PhoneInputWrapper, SubmitButton,
	TextContainer,
	TextWithIconWrapper,
	TypeNumberMessage
} from "./CommonUI";
import { validateCode, createCustomer, replaceToken, resendValidatePhone } from "./Actions";
import FullPageLoader from "../../Components/FullPageLoader";
import { Button } from "rmwc/Button/index";
import Sizes from "../../Assets/Sizes";
import { getSafely } from "@tomeravni/easybizy-js-common/common";


const FullNameWrapper = styled.div`
  visibility: ${ p => p.visible ? 'visible' : 'hidden' };
  opacity: ${ p => p.visible ? 1 : 0 };
  transform: ${ p => p.visible ? 'none' : 'translateX(100%)' };
  margin-top: -100px;
  transition: all 500ms;
  position: relative;
`;


const SendAnotherCodeWrapper = styled.div`
  .appear-enter {
    opacity: 0;
    max-height: 0;
    z-index: 9;
    transform: translateX(-100%);
  }

  .appear-enter-active {
    z-index: 9;
    opacity: 1;
    transition: opacity 500ms, transform 500ms, max-height 500ms;
    transform: translateX(0);
    max-height: 100px;
  }

  p {
    color: ${ p => p.theme.colors.primaryText };
  }
`;

const SendAnotherContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;


const SecondaryButton = styled(Button).attrs({
	className: 'existing-meetings-dialog__secondary-button',
})`
  --mdc-theme-primary: ${ p => p.theme.colors.primaryText };

  height: auto;
  padding-top: ${ Sizes.smallMargin };
  padding-bottom: ${ Sizes.smallMargin };
  border-radius: ${ Sizes.defaultBorderRadius };
  font-family: inherit;
  border: none;
  font-weight: 400;
  color: ${ p => p.theme.colors.primaryText };
  text-decoration: underline;

`;


class Validate extends ContainerPage {
	state = { validationValue: '', fullName: '', showNotReceivedCode: false, sendingAnotherCode: false };

	constructor(props) {
		super(props);
		this.allowAnonymous = true;
		this.nextRoute = Routes.pickServices;
	}

	onChange = (e) => {
		const re = /^[0-9\-\b]+$/;
		const currentValue = e.target.value;
		if (currentValue === '' || re.test(currentValue)) {
			let desiredLength = 6;
			this.safeSetState({ validationValue: currentValue, valid: currentValue.length >= desiredLength });
		}
	};

	onChangeFullName = (e) => {
		let newValue = e.target.value;
		this.safeSetState({ fullName: newValue, validFullName: newValue.trim().split(' ').length > 1 });
	};

	validate() {
		this.props.validateCode(this.state.validationValue, this.props.config.Token, (err, res) => {
			if (err) {
				this.showToastMessage(this.props.intl.formatMessage({ id: err.message }));
			} else if (res.updatedToken) {
				this.props.replaceToken(res.updatedToken);
				this.showToastMessage(this.props.intl.formatMessage({ id: 'app.niceToMeetYou' }));
				setTimeout(() => {
					this.navigate(PICK_SERVICES_PATH, res.updatedToken)
				}, 1500);

			} else {
				if (this.sendAnotherTimer) {
					clearTimeout(this.sendAnotherTimer);
					this.sendAnotherTimer = null;
				}

				if (!this.props.config.EnableNewCustomers) {
					return this.fatalError('app.not_allowing_new_customers')

				}


				this.setState({ fullNameMode: true, showNotReceivedCode: false });
			}
		});
	}

	componentWillUnmount() {
		super.componentWillUnmount();
	}

	didNavigate = false;

	componentWillReceiveProps(nextProps, nextContext) {
		if (!this.didNavigate && nextProps.config && nextProps.config.Customer) {
			this.didNavigate = true;
			this.startOver();
		}
	}

	componentDidMount() {
		super.componentDidMount();
		setTimeout(() => {
			if (!this.props.validRoute) {
				this.loadPreviousRoute();
			}

			this.inputField.focus();
		}, 500);

		this.sendAnotherTimer = setTimeout(() => {
			this.setState({
				showNotReceivedCode: true
			})
		}, 15000)

	}

	createCustomer() {
		this.pageLoader.load(this.props.intl.formatMessage({ id: 'app.creating_customer' }));
		let fullName = this.state.fullName.trim().split(' ');
		if (fullName.length === 1) {
			fullName.push('');
		}

		this.props.createCustomer(this.props.config.Token, fullName[0].trim(), fullName.slice(1).join(' ').trim(), (err, res) => {
			if (err || !res.updatedToken) {
				this.pageLoader.error();
				this.showToastMessage(this.props.intl.formatMessage({ id: err.message }));
			} else {
				this.pageLoader.done();
				setTimeout(() => {
					this.props.replaceToken(res.updatedToken);
					this.navigate(PICK_SERVICES_PATH, res.updatedToken)
				}, 1500);
			}
		});
	}

	sendAnotherCode = () => {
		this.setState({
			sendingAnotherCode: true
		})

		this.props.resendValidateCode(this.props.config.Token, (err) => {
			this.showToastMessage(this.props.intl.formatMessage({ id: getSafely(['message'], err, 'sent_again') }));
		})

	}

	render() {
		const ltr = !this.props.intl.locale.includes('he');
		const toolbarLogo = getSafely(['theme', 'properties', 'avatarImage'], window) || (this.props.config && this.props.config.Logo) || '';

		return (
			<div className="transition-item detail-page">
				<CoreWrapper padding={ true } loading={ !this.props.config || this.props.validating } ltr={ ltr }>
					<ToolbarWithLogo imageUri={ toolbarLogo } ltr={ ltr }
									 rootUri={ this.getRoutePrefix() }>
						<ProgressTracker progress={ this.props.progress } current={ 0 } visible={ true }/>

					</ToolbarWithLogo>

					<TopWrapper justify="start" align="start">
						<CenterContainer>
							<H2 center={ true }><FormattedMessage id="schedule.identifyHeader"/>,</H2>
							<H1><FormattedMessage id="schedule.letsMeet"/>&nbsp;<span>🙏</span></H1>
						</CenterContainer>
						<TextContainer>
							<PhoneInputWrapper visible={ !this.state.fullNameMode }>
								<TextWithIconWrapper>
									<FullWidthInput short={ true }
													pattern="[0-9]*"
													autoComplete="one-time-code"
													inputMode="numeric"
													onKeyDown={ (e) => e.key === 'Enter' && this.state.valid && this.validate() }
													disabled={ this.state.validateMode }
													value={ this.state.value } onChange={ this.onChange }
													innerRef={ r => this.inputField = r }
									/>
									<SubmitButton outlined
												  disabled={ !this.state.valid }
												  onClick={ () => this.validate() }><FormattedMessage
										id="app.send"/></SubmitButton>
								</TextWithIconWrapper>
								<TypeNumberMessage short={ true }><FormattedMessage
									id="schedule.verificationCode"/></TypeNumberMessage>
							</PhoneInputWrapper>
							<SendAnotherCodeWrapper>
								<CSSTransition
									in={ this.state.showNotReceivedCode }
									unmountOnExit
									timeout={ 1500 }
									classNames="appear">
									<SendAnotherContent>
										<p><FormattedMessage id="did_not_receive_code"/></p>
										<SecondaryButton
											disabled={ this.state.sendingAnotherCode }
											onClick={ () => this.sendAnotherCode() }><FormattedMessage
											id="send_again"/></SecondaryButton>
									</SendAnotherContent>
								</CSSTransition>
							</SendAnotherCodeWrapper>
							<FullNameWrapper visible={ this.state.fullNameMode }>
								<TextWithIconWrapper>
									<FullWidthInput short={ true }
													onKeyDown={ (e) => e.key === 'Enter' && this.state.validFullName && this.createCustomer() }
													disabled={ this.props.creatingCustomer }
													value={ this.state.fullName } onChange={ this.onChangeFullName }
													innerRef={ r => this.fullNameInputField = r }
													id={ `text-full-name-${ Math.random() * 1000000 }` }/>
									<SubmitButton outlined
												  disabled={ !this.state.validFullName }
												  onClick={ () => this.createCustomer() }><FormattedMessage
										id="app.update"/></SubmitButton>
								</TextWithIconWrapper>
								<TypeNumberMessage short={ true }><FormattedMessage
									id="schedule.fullName"/></TypeNumberMessage>
							</FullNameWrapper>
						</TextContainer>
						<BottomWrapper empty={ true }>
							<PoweredBy/>
						</BottomWrapper>
					</TopWrapper>
				</CoreWrapper>
				<FullPageLoader ref={ r => this.pageLoader = r }/>
				<Toast ref={ (toast) => this.toast = toast }/>
			</div>
		)
	}
}

/** Styled-Components **/

/** END OF Styled-Components **/

const mapStateToProps = state => {
	return {
		loading: state.schedule.fetchingConfig,
		config: state.schedule.config,
		progress: state.schedule.progress,
		validating: state.identify.validatingCode,
		codeValidated: state.identify.codeValidated,
		creatingCustomer: state.identify.creatingCustomer,
		updatedToken: state.identify.updatedToken,
		validRoute: (state.schedule.stateParams && state.schedule.stateParams.mobile && state.schedule.stateParams.validation_hash)
	};
};

const mapDispatchToProps = dispatch => {
	return {
		validateCode: (code, context, callback) => dispatch(validateCode(code, context, callback)),
		resendValidateCode: (token, callback) => dispatch(resendValidatePhone(token, callback)),
		createCustomer: (token, firstName, lastName, callback) => dispatch(createCustomer(token, firstName, lastName, callback)),
		replaceToken: (updatedToken) => dispatch(replaceToken(updatedToken)),

	}
};


export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(Validate));
